import { FC, Fragment, useCallback } from 'react';

import { ChangeHistoryType } from 'utils/constants/admin';
import { CampaignStatus } from 'utils/constants/dashboard';

import { MenuItem } from 'bloko/blocks/drop';

import useTrls from 'hooks/translation/useTrls';

import { fetchChangeHistoryEvents } from 'components/CampaignAdminActions/MenuItems/fetchChangeHistoryEvents';
import { fetchRemainderBudgets } from 'components/CampaignAdminActions/RemainderBudgetsModal/fetchRemainderBudgets';
import { fetchSourceAccounts } from 'components/CampaignAdminActions/SourceAccountsModal/fetchSourceAccounts';

import { setCampaignArchiveModalShow } from 'store/autoReducers';
import { setIdAdminAction, setLoadCampaignAdminAction } from 'store/models/adminCampaignAction';
import { FrontendStatusType } from 'store/models/dashboard';
import { useDispatch } from 'store/utils';

interface MenuItemsProps {
    campaignId: number;
    close?: () => void;
    frontendStatus: FrontendStatusType;
}

const MenuItems: FC<MenuItemsProps> = ({ campaignId, close, frontendStatus }) => {
    const dispatch = useDispatch();
    const trl = useTrls();

    const onClickChangeHistory = useCallback(() => {
        void dispatch(fetchChangeHistoryEvents(ChangeHistoryType.Campaign, campaignId));
        close?.();
    }, [campaignId, close, dispatch]);

    const onClickRemainderBudgets = useCallback(() => {
        void dispatch(fetchRemainderBudgets(campaignId));
        close?.();
    }, [campaignId, close, dispatch]);

    const onClickSourceAccounts = useCallback(() => {
        void dispatch(fetchSourceAccounts(campaignId));
        close?.();
    }, [campaignId, close, dispatch]);

    const onClickArchiveVacancy = useCallback(() => {
        close?.();
        dispatch([setLoadCampaignAdminAction(true), setIdAdminAction(campaignId), setCampaignArchiveModalShow(true)]);
    }, [campaignId, close, dispatch]);

    return (
        <Fragment>
            <MenuItem onClick={onClickChangeHistory}>{trl('campaign.info.sudo.actions.changeHistory')}</MenuItem>
            <MenuItem onClick={onClickRemainderBudgets}>{trl('campaign.info.sudo.actions.remainderBudgets')}</MenuItem>
            <MenuItem onClick={onClickSourceAccounts}>{trl('campaign.info.sudo.actions.sourceAccounts')}</MenuItem>
            {frontendStatus !== CampaignStatus.Archived && (
                <MenuItem onClick={onClickArchiveVacancy}>{trl('campaign.info.sudo.actions.archiveCampaign')}</MenuItem>
            )}
        </Fragment>
    );
};

export default MenuItems;
